// extracted by mini-css-extract-plugin
module.exports = {"control":"SidebarLinks_control__BE_Ma","group":"SidebarLinks_group__LM9Cb","link":"SidebarLinks_link__8jeC6","chevron":"SidebarLinks_chevron__dJaPL"};